module.exports = __webpack_public_path__ + "img/pay.35ac8048.svg";